<template>
  <svg
    width="30px"
    height="30px"
    version="1.1"
    viewBox="0 0 700 700"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <path
        d="m375.8 260.47v115.5c0 2.3203-0.92188 4.5469-2.5625 6.1875-1.6406 1.6406-3.8672 2.5625-6.1875 2.5625h-34.125c-4.832 0-8.75-3.918-8.75-8.75v-115.5c0-4.832 3.918-8.75 8.75-8.75h34.125c4.832 0 8.75 3.918 8.75 8.75zm-25.805-85.215c-6.8438 0-13.406 2.7188-18.246 7.5586s-7.5586 11.402-7.5586 18.246 2.7188 13.406 7.5586 18.246c4.8398 4.8398 11.402 7.5547 18.246 7.5547s13.406-2.7148 18.246-7.5547c4.8398-4.8398 7.5586-11.402 7.5586-18.246s-2.7188-13.406-7.5586-18.246-11.402-7.5586-18.246-7.5586zm222.39 104.75c0 58.98-23.43 115.55-65.137 157.25-41.707 41.707-98.273 65.137-157.25 65.137s-115.55-23.43-157.25-65.137c-41.707-41.707-65.137-98.273-65.137-157.25s23.43-115.55 65.137-157.25c41.707-41.707 98.273-65.137 157.25-65.137 58.961 0.066406 115.49 23.52 157.18 65.211 41.691 41.691 65.145 98.219 65.211 157.18zm-26.25 0c0-52.02-20.664-101.91-57.449-138.69-36.781-36.785-86.672-57.449-138.69-57.449s-101.91 20.664-138.69 57.449c-36.785 36.781-57.449 86.672-57.449 138.69s20.664 101.91 57.449 138.69c36.781 36.785 86.672 57.449 138.69 57.449 52-0.0625 101.86-20.746 138.62-57.516s57.453-86.625 57.516-138.62z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'description',
};
</script>
